var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHelpSentIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.31494 8.79646C2.31494 8.54077 2.52222 8.3335 2.7779 8.3335H40.7409C40.9966 8.3335 41.2038 8.54077 41.2038 8.79646V41.2039C41.2038 41.4596 40.9966 41.6668 40.7409 41.6668H2.7779C2.52222 41.6668 2.31494 41.4596 2.31494 41.2039V8.79646Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.77778 6.01807H40.7407C42.2749 6.01807 43.5185 7.26172 43.5185 8.79584V41.2033C43.5185 42.7374 42.2749 43.981 40.7407 43.981H2.77778C1.24366 43.981 0 42.7374 0 41.2033V8.79584C0 7.26172 1.24365 6.01807 2.77778 6.01807ZM2.77778 8.33288C2.52209 8.33288 2.31482 8.54016 2.31482 8.79584V41.2033C2.31482 41.4589 2.52209 41.6662 2.77778 41.6662H40.7407C40.9964 41.6662 41.2037 41.4589 41.2037 41.2033V8.79584C41.2037 8.54016 40.9964 8.33288 40.7407 8.33288H2.77778Z",
    fill: "#1F2D5C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.31494 16.666H41.2038V8.79565C41.2038 8.53996 40.9966 8.33268 40.7409 8.33268H2.7779C2.52222 8.33268 2.31494 8.53996 2.31494 8.79565V16.666Z",
    fill: "#3AC09D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2682 8.3335C11.629 8.3335 11.1108 7.81531 11.1108 7.17609L11.1108 1.15757C11.1108 0.518352 11.629 0.000163056 12.2682 0.000163028C12.9075 0.000163 13.4257 0.518351 13.4257 1.15757L13.4257 7.17609C13.4257 7.81531 12.9075 8.3335 12.2682 8.3335Z",
    fill: "#1F2D5C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.4909 8.3335C33.8517 8.3335 33.3335 7.81531 33.3335 7.17609L33.3335 1.15757C33.3335 0.518352 33.8517 0.000163056 34.4909 0.000163028C35.1301 0.000163 35.6483 0.518351 35.6483 1.15757L35.6483 7.17609C35.6483 7.81531 35.1301 8.3335 34.4909 8.3335Z",
    fill: "#1F2D5C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2036 28.5775L19.9073 31.9445L27.3147 24.5371",
    stroke: "#3AC09D",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpSentIcon);
export default __webpack_public_path__ + "static/media/help-sent-icon.95940182.svg";
export { ForwardRef as ReactComponent };